import { AppointmentPackage, themes, ValidPromo } from 'kb-shared';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { ReactComponent as SecureLockIcon } from '../../assets/icons/secure-lock.svg';
import { typography } from '../../styled';
import { showErrorToast } from '../../utilities/notificationUtils';
import CreditCardEntry from './components/CreditCardEntry';
import PromoCodeEntry from './components/PromoCodeEntry';

const { colors } = themes;
const {
  sans: { H3 },
  spans: { Bold }
} = typography;

interface ContainerProps {
  shouldDisplay?: boolean;
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  opacity: ${({ shouldDisplay }: ContainerProps) => (shouldDisplay ? '1.0' : '0.0')};
  margin-top: 40px;
  transition: opacity 400ms;
  width: 100%;
`;

const CreditCardContainer = styled.div`
  background: ${colors.KBWhite};
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.2);
  padding: 30px;
  z-index: 2;
`;

const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 20px;
`;

const Title = styled(H3)`
  margin: 0;
  margin-right: 10px;
`;

type Props = {
  shouldDisplay: boolean;
  onPromoApply: (code: ValidPromo) => void;
  product: AppointmentPackage;
};

const Payment = (props: Props) => {
  const { shouldDisplay, onPromoApply, product } = props;
  const [error, setError] = useState();

  useEffect(() => {
    if (!error) return;

    let errorMsg = "We're sorry something went wrong please try again";
    if (error && error.message.includes('insufficient funds')) {
      errorMsg = 'Your card has insufficient funds.';
    }
    if (error && error.message.includes('Your card was declined')) {
      errorMsg = 'Your card was declined.';
    }
    if (error && error.message.includes('security code')) {
      errorMsg = "Your card's security code is incorrect.";
    }
    if (error && error.message.includes('Your card has expired')) {
      errorMsg = 'Your card has expired.';
    }
    if (error && error.message.includes('An error occurred while processing your card')) {
      errorMsg = 'An error occurred while processing your card. Please try again in a little bit.';
    }
    // Entering an invalid CC, CVC or expiration number results in err being undefined.
    if (!error) {
      errorMsg =
        'Please verify that you have correctly entered your credit card number, expiration date and security code.';
    }

    showErrorToast(errorMsg);
    // @ts-ignore
    setError();
  }, [error]);

  return (
    <Container shouldDisplay={shouldDisplay}>
      <CreditCardContainer>
        <TitleContainer>
          <Title>
            <Bold>Payment Method</Bold>
          </Title>
          <SecureLockIcon />
        </TitleContainer>
        <CreditCardEntry />
      </CreditCardContainer>
      <PromoCodeEntry onPromoApply={onPromoApply} product={product} />
    </Container>
  );
};

export default Payment;
